exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table #todos1{font-family:arial,sans-serif;border-collapse:collapse;width:100%}th,tr{border:1px solid #ddd;text-align:left;padding:8px}tr:nth-child(2n){background-color:#ddd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d8d0a7b4","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Inquilino-ver.vue
// module id = 104
// module chunks = 0